import React from "react";
import { usePageMeta } from "../hooks/usePageMeta";
import { FinalCtaBand } from "../components/FinalCtaBand";
type UpcomingPageProps = {
  title: string;
  heading: string;
  eyebrow: string;
  intro: string;
};

/** Temporary page shell — each route is rebuilt to full spec in the next phase. */
export function UpcomingPage({
  title,
  heading,
  eyebrow,
  intro
}: UpcomingPageProps) {
  usePageMeta({
    title,
    description: intro
  });
  return <>
      <section className="section-y gutter bg-sand" data-id="element-452" data-mp="kjipb88rh2kw">
        <p className="eyebrow text-gold-hover" data-id="element-453" data-mp="pck6jmwfxe7n">{eyebrow}</p>
        <h1 className="h1-fluid mt-5 max-w-[18ch] font-serif font-normal text-navy" data-id="element-454" data-mp="pe50baaxkt4g">{heading}</h1>
        <p className="measure mt-8 text-xl text-muted" data-id="element-455" data-mp="all3eredjhvg">{intro}</p>
      </section>
      <FinalCtaBand showForm={false} data-id="element-456" data-mp="fmsep0fq6z6v" />
    </>;
}